import React, { useCallback } from "react";
import { useStore } from "react-redux";
import { Form, Row } from "react-bootstrap";

import { Field } from "../../utils/components/form";
import PERSONART from "../../utils/enums/PERSONART";
import { InputError } from './InputError';

const Select = ({ input, meta, inputClass, attributes, onChange, isMaShop, label }) => {
  const onSelect = useCallback((e) => {
    if (input && typeof input.onChange === "function") {
      input.onChange(e);
    }
    if (typeof onChange === "function") {
      onChange(e);
    }
  }, [onChange, input]);

  return (
    <>
      <Form.Group className={inputClass + (meta && meta.touched && meta.error ? " is-invalid" : "")}>
        <Form.Select
          {...input}
          aria-label={label}
          size="lg"
          isInvalid={meta && meta.touched && meta.error}
          isValid={meta && meta.touched && !meta.error}
          onChange={onSelect}
          {...attributes}
        >
          <option value="">Personenart auswählen...</option>
          <option value={PERSONART.NATUERLICHE_PERSON.KUERZEL}>{PERSONART.NATUERLICHE_PERSON.BEZEICHNUNG}</option>
          {isMaShop
            ? <option value={PERSONART.JURISTISCHE_PERSON.KUERZEL}>{PERSONART.JURISTISCHE_PERSON.BEZEICHNUNG}</option>
            : null}
        </Form.Select>
      </Form.Group>
      <InputError meta={meta} />
    </>
  );
};

export const InputPersonArt = (props) => {
  const { name, validate, onChange, label, labelClass, inputClass, required, ...attributes } = props || {};
  const { configStorage } = useStore().getState();

  if (configStorage.isKundenShop()) {
    return <Field
      name={name}
      type="hidden"
      value={PERSONART.NATUERLICHE_PERSON.KUERZEL}
      component="input"
    />;
  }

  const requiredStar = required ? "*" : "";
  return (
    <Form.Group as={Row} controlId={name} className="pb-1">
      <Form.Label className={labelClass + " fs-4"}>
        {label}{requiredStar}
      </Form.Label>
      <Field
        name={name}
        validate={validate}
        required={required}
      >
        {({ input, meta }) => {
          return (
            <Select
              input={input}
              meta={meta}
              inputClass={inputClass}
              attributes={attributes}
              onChange={onChange}
              isMaShop={configStorage.isMaShop()}
              label={label}
            />
          );
        }}
      </Field>
    </Form.Group>
  );
};
